import JSONP from 'jsonp'
import Axios from 'axios'
import { Toast } from '@zz-common/zz-ui'
import qs from 'qs'
import { cookie } from '@zz-common/zz-utils';

// const { TT } = cookie.getPPU();

const protocal = `${window.location.protocol}//`
const baseURL = window.location.hostname === 'localhost' ? '/test' : `${protocal}`

const $axios = Axios.create({
  timeout: 5000,
  withCredentials: true
})

$axios.interceptors.request.use((config) => {
  // 在发送请求之前做某件事
  if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
    // 序列化(后端post需要form结构)
    config.data = qs.stringify(config.data)
  }
  return config
})
const formatBase = (url) => {
  // eslint-disable-next-line prefer-regex-literals
  const strRegex = new RegExp('^((https|http)?:?//)')
  return strRegex.test(url) ? url.replace(strRegex, protocal) : `${baseURL}${url}`
}

const Jsonp = (url, params = {}, opts) => {
  let query = url.indexOf('?') === -1 ? '?' : '&'
  query += Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&')
  const URL = `${formatBase(url)}${query}`
  return new Promise((resolve, reject) => {
    JSONP(URL, opts, (error, res = {}) => {
      if (error) {
        console.error('jsonp Error: ', error)
        reject(Error(error))
      }
      console.log('Jsonp url', url);
      if (url.indexOf('gr.zhuanzhuan.com') > -1) return resolve(res) //兼容架构接口返回的数据结构不同
      const { nofilter } = opts
      if (nofilter) {
        resolve(res)
      } else if (+res.respCode === 0) {
        resolve(res.respData || res.data || {})
      } else {
        const errMsg = res.errMsg || res.msg || res.respMsg || '网络异常，请稍后重试'
        reject(errMsg)
        Toast.fail(errMsg)
      }
    })
  })
}

const Json = (url, params = {}, opts, method = 'get') => {
  method = method.toLowerCase()
  const URL = `${formatBase(url)}`
  const { headers = {} } = opts
  return $axios(
    Object.assign(opts, {
      [method === 'get' ? 'params' : 'data']: params,
      url: URL,
      method,
      headers: {
        'Csrf-Token': cookie.getPPU().TT || '',
        ...headers
      }
    })
  )
    .then((res = {}) => res.data)
    .then((res = {}) => {
      return new Promise((resolve, reject) => {
        if (url.indexOf('hi.zhuanzhuan.com') > -1) return resolve(res)
        const { respCode, respData, data } = res
        const errMsg = res.errMsg || res.msg || res.respMsg || '网络异常，请稍后重试'
        if (+respCode === 0) {
          resolve(respData || data)
        } else {
          reject(respData || data)
          Toast.fail(errMsg)
        }
      })
    })
}

export default (url, params = {}, opts = {}) => {
  const { method } = opts
  return method && method.toUpperCase() === 'JSONP'
    ? Jsonp(url, params, opts)
    : Json(url, params, opts, method)
}
